import * as React from 'react'
import { useParams } from 'react-router-dom'
import { Loader } from '@/ui/feedback'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { useRoleEditor } from './useRoleEditor'
import { RolesListLayout } from './RolesListLayout'
import { ErrorBox } from './RolesListLayout'
import { rolesKey } from './catalog'
import { CompanyRoleError } from '@/lib/api/company/roles'

/** Zakładka „Role” - firmy albo konta usługowego (companyId = id konta). */
export const CompanyRolesView: React.FC<{ companyId: string }> = ({ companyId }) => {
  const { t } = useLocalize()
  const editor = useRoleEditor(companyId)

  if (editor.query.isLoading) return <Loader />
  if (editor.query.isError) {
    const denied = editor.query.error instanceof CompanyRoleError && editor.query.error.code === 'NOT_AUTHORIZED'
    return (
      <div className="tw-p-4">
        <ErrorBox text={t(rolesKey(denied ? 'errors.NOT_AUTHORIZED' : 'errors.loadFailed'))} />
      </div>
    )
  }

  return <RolesListLayout editor={editor} companyId={companyId} />
}

export const RolesListPage: React.FC = () => {
  const { companyId } = useParams<{ companyId: string }>()
  return <CompanyRolesView companyId={companyId!} />
}
